import { render, staticRenderFns } from "./customProfileModal.vue?vue&type=template&id=67834d8b"
import script from "./customProfileModal.vue?vue&type=script&lang=js"
export * from "./customProfileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports